// extracted by mini-css-extract-plugin
export default {"container":"AttributeImage_container__-Uo1N"};